(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["br-book-landing-backup"] && !Shopify.designMode) return;
  try {
    
(function() {
  var buttons = document.querySelectorAll('.br-book-landing__buy-button');
  buttons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) { window.location.href = '/checkout'; return; }
      
      var updates = {};
      updates[variantId] = 1;
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var totalQty = 0;
        if (data.items) {
          data.items.forEach(function(item) { totalQty += item.quantity; });
        }
        if (totalQty === 0) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
        }
      })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() { window.location.href = '/checkout'; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-book-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-brl]');
  if (!root) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(fn) { try { return fn(window.localStorage); } catch (e) { return null; } }

  /* ---- Buy buttons: put exactly this book in the cart, then go to checkout ---- */
  root.querySelectorAll('.brl-buy').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) { window.location.href = '/checkout'; return; }
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      var updates = {}; updates[variantId] = 1;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var inCart = (data.items || []).some(function (i) { return String(i.variant_id) === String(variantId); });
          if (!inCart) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });
          }
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart/' + variantId + ':1'; });
    });
  });

  /* ---- Mobile menu ---- */
  var header = root.querySelector('[data-brl-header]');
  var toggle = root.querySelector('[data-brl-menu-toggle]');
  if (header && toggle) {
    var setOpen = function (open) {
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    toggle.addEventListener('click', function () { setOpen(!header.classList.contains('is-open')); });
    root.querySelectorAll('.brl-nav__link').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && header.classList.contains('is-open')) { setOpen(false); toggle.focus(); } });
  }

  /* ---- Rolling per-visitor offer countdown ---- */
  var timer = root.querySelector('[data-brl-timer]');
  if (timer) {
    var hours = parseFloat(timer.getAttribute('data-hours')) || 3;
    var KEY = 'brl_offer_deadline';
    var getDeadline = function () {
      var d = parseInt(store(function (s) { return s.getItem(KEY); }), 10);
      if (!d || d <= Date.now()) {
        d = Date.now() + hours * 3600000;
        store(function (s) { s.setItem(KEY, String(d)); });
      }
      return d;
    };
    var deadline = getDeadline();
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var tick = function () {
      var left = deadline - Date.now();
      if (left <= 0) { deadline = getDeadline(); left = deadline - Date.now(); }
      var s = Math.floor(left / 1000);
      timer.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Sticky buy bar: show once the hero CTA scrolls out of view ---- */
  var sticky = root.querySelector('[data-brl-sticky]');
  var heroCta = root.querySelector('[data-brl-hero-cta]');
  var finalCta = root.querySelector('#buy');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    var heroOut = false, finalIn = false;
    var update = function () {
      var show = heroOut && !finalIn;
      sticky.classList.toggle('is-visible', show);
      if (show) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); }
    };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { heroOut = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    }).observe(heroCta);
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { finalIn = en.isIntersecting; });
        update();
      }, { threshold: 0.15 }).observe(finalCta);
    }
  }

  /* ---- Looping carousels (reviews + excerpt pages) ---- */
  root.querySelectorAll('[data-brl-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-brl-track]');
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = car.querySelector('[data-brl-dots]');
    var prev = car.querySelector('[data-brl-prev]');
    var next = car.querySelector('[data-brl-next]');
    var autoplay = parseInt(car.getAttribute('data-autoplay'), 10) || 0;
    var index = 0, timerId = null, dots = [];

    var perView = function () { return parseInt(getComputedStyle(car).getPropertyValue('--per-view'), 10) || 1; };
    var pages = function () { return Math.max(1, slides.length - perView() + 1); };

    var buildDots = function () {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'brl-carousel__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { go(n); restart(); }); })(i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
      var controls = car.querySelector('.brl-carousel__controls');
      if (controls) controls.hidden = pages() < 2;
    };

    var go = function (n) {
      var total = pages();
      index = (n + total) % total; // loop both directions
      track.style.transform = 'translateX(' + (-index * 100 / perView()) + '%)';
      slides.forEach(function (s, i) {
        var visible = i >= index && i < index + perView();
        s.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    };

    var stop = function () { if (timerId) { clearInterval(timerId); timerId = null; } };
    var start = function () { if (autoplay && !reduceMotion && pages() > 1) { stop(); timerId = setInterval(function () { go(index + 1); }, autoplay); } };
    var restart = function () { stop(); start(); };

    if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(index + 1); restart(); });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    car.addEventListener('focusin', stop);
    car.addEventListener('focusout', start);

    var startX = null;
    car.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    car.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX; startX = null;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); restart(); }
    });

    var lastPer = perView();
    window.addEventListener('resize', function () {
      if (perView() !== lastPer) { lastPer = perView(); buildDots(); go(Math.min(index, pages() - 1)); }
    });

    buildDots();
    go(0);
    start();
  });

  /* ---- Dialog helpers ---- */
  var openDialog = function (dlg) { if (!dlg) return; if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); } };
  var closeDialog = function (dlg) { if (!dlg) return; if (typeof dlg.close === 'function') { dlg.close(); } else { dlg.removeAttribute('open'); } };
  root.querySelectorAll('dialog.brl-modal').forEach(function (dlg) {
    dlg.querySelectorAll('[data-brl-close]').forEach(function (b) { b.addEventListener('click', function () { closeDialog(dlg); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(dlg); });
  });

  /* ---- Video modal ---- */
  var video = root.querySelector('[data-brl-video]');
  if (video) {
    var slot = video.querySelector('[data-brl-video-slot]');
    var tpl = slot && slot.querySelector('template');
    root.querySelectorAll('[data-brl-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (tpl) {
          Array.prototype.slice.call(slot.children).forEach(function (c) { if (c !== tpl) c.remove(); });
          slot.appendChild(tpl.content.cloneNode(true));
        }
        openDialog(video);
      });
    });
    video.addEventListener('close', function () {
      if (tpl) Array.prototype.slice.call(slot.children).forEach(function (c) { if (c !== tpl) c.remove(); });
    });
  }

  /* ---- Free du'a card modal: inline trigger + desktop exit intent ---- */
  var optin = root.querySelector('[data-brl-optin]');
  if (optin) {
    root.querySelectorAll('[data-brl-optin-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDialog(optin); });
    });
    var SEEN = 'brl_optin_seen';
    var alreadyPosted = !!root.querySelector('[data-brl-posted]') || /customer_posted=true/.test(location.search);
    var recentlySeen = function () {
      var t = parseInt(store(function (s) { return s.getItem(SEEN); }), 10);
      return t && (Date.now() - t) < 7 * 864e5;
    };
    if (optin.getAttribute('data-exit') === 'true' && !alreadyPosted && window.matchMedia('(pointer: fine)').matches) {
      var armed = false;
      setTimeout(function () { armed = true; }, 8000);
      document.addEventListener('mouseout', function onOut(e) {
        if (!armed || e.relatedTarget || e.clientY > 10) return;
        if (recentlySeen() || document.querySelector('dialog[open]')) return;
        store(function (s) { s.setItem(SEEN, String(Date.now())); });
        openDialog(optin);
        document.removeEventListener('mouseout', onOut);
      });
    }
    if (alreadyPosted) {
      var nl = root.querySelector('#free-card');
      if (nl) nl.scrollIntoView({ block: 'center' });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
